var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdddwdw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.771 0H5.229C1.953 0 0 1.953 0 5.229v7.533C0 16.047 1.953 18 5.229 18h7.533c3.276 0 5.229-1.953 5.229-5.229V5.229C18 1.953 16.047 0 12.771 0M14.4 9.675H9.675V14.4a.68.68 0 0 1-.675.675.68.68 0 0 1-.675-.675V9.675H3.6A.68.68 0 0 1 2.925 9a.68.68 0 0 1 .675-.675h4.725V3.6A.68.68 0 0 1 9 2.925a.68.68 0 0 1 .675.675v4.725H14.4a.68.68 0 0 1 .675.675.68.68 0 0 1-.675.675"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdddwdw);
export default __webpack_public_path__ + "static/media/adddwdw.70edf94a0a44a52167e4d859b4fd0435.svg";
export { ForwardRef as ReactComponent };